import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Subscription } from 'rxjs';
import { TicketEmployee } from 'src/app/_provider/tickets/ticket.service';
import { Ticket, TicketBase } from '../../_interfaces/ticket';
import { DarkmodeService } from '../../_provider/darkmode.service';

@Component({
  selector: 'app-ticket',
  templateUrl: './ticket.component.html',
  styleUrls: ['./ticket.component.scss'],
})
export class TicketComponent implements OnInit {

  @Input() ticket: TicketBase
  @Input() isMobile: boolean = false
  @Input() paddingLeft: boolean = true
  @Input() translateLeft: boolean = false
  @Input() selected: boolean = false
  @Output() clicked: EventEmitter<{ticket: TicketBase, event: any}> = new EventEmitter<{ticket: TicketBase, event: any}>(null)

  public isDarkmode: boolean
  private darmodeSub: Subscription

  constructor(
    private darkmode: DarkmodeService,
    private ticketSrv: TicketEmployee.TicketService
  ) {

    this.darmodeSub = this.darkmode.isDarkMode.subscribe((result: boolean)=>{
      this.isDarkmode = result
    })
   }

  ngOnInit() {}

  ngOnDestroy(){
    this.darmodeSub.unsubscribe()
  }

  public openTicket(event: any, ticket: TicketBase){
    if(event.metaKey || event.ctrlKey) this.ticketSrv.openInNewTab(ticket.id)
    else this.clicked.emit({ticket: ticket, event: event})
  }

}
